import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditModemTypeForm from './forms/EditModemTypeForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { createModemTypeAction } from '../actions/modemTypesActions'
import { createQueryString } from '../utils/queryParams'

class CreateModemType extends Component {
  static propTypes = {
    carriers: PropTypes.arrayOf(PropTypes.object).isRequired,
    getAllCarriers: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.getAllCarriers(createQueryString({ perPage: 'all' }))
  }

  render() {
    const { carriers } = this.props
    const crumbs = [
      <Anchor to="/inventory/all">Inventory</Anchor>,
      <Anchor to="/inventory/all/modems">Modems</Anchor>,
      'Create Modem Type',
    ]

    return (
      <section className="CreateModemType">
        <FormHeader crumbs={crumbs} />
        <EditModemTypeForm
          submitAction={createModemTypeAction}
          initialValues={{ carrierIds: [], countries: [] }}
          carriers={carriers}
        />
      </section>
    )
  }
}

export default CreateModemType
